import type { MediaItem } from '../types/animatronic';

export function processMediaItems(data: any): MediaItem[] {
  if (!data) return [];

  try {
    // Parse JSON string if needed
    const mediaData = typeof data === 'string' ? JSON.parse(data) : data;

    // Handle array format
    if (Array.isArray(mediaData)) {
      return mediaData.map(item => ({
        url: item.url,
        type: item.type || determineMediaType(item.url),
        credit: item.credit || '',
        credit_url: item.credit_url // This will be undefined for old format items
      }));
    }

    return [];
  } catch (err) {
    console.error('Error processing media:', err);
    return [];
  }
}

function determineMediaType(url: string): 'image' | 'video' {
  const videoPatterns = [
    /youtube\.com/,
    /youtu\.be/,
    /vimeo\.com/,
    /player\.cloudinary\.com/
  ];
  
  return videoPatterns.some(pattern => pattern.test(url)) ? 'video' : 'image';
}